<template>
  <div
    component-name="carousel-splitview-portrait"
    data-skin="black"
    class="flex flex-col gap-lg"
  >
    <div
      v-for="(item, index) in items"
      class="relative top-0 left-0 flex flex-col w-full overflow-hidden"
      :style="`z-index: ${items.length - index};`"
    >
      <!-- TOP BOX -->
      <section
        class="overflow-hidden w-full bg-skin-base grid grid-cols-1 h-[50vh] max-h-[50vh]"
      >
        <media
          class="w-full h-full row-start-1 row-end-2 overflow-hidden col-span-full brightness-75"
          v-bind="item.box1.asset"
          :sizes="sizes"
          :loading="index > 1 || forceLazyLoading ? 'lazy' : 'eager'"
          :use-bg="false"
          reveal="slide-from-up"
        />

        <div
          class="relative top-0 left-0 flex items-center justify-center row-start-1 row-end-2 z-2 col-span-full p-edge"
        >
          <wrapper-reveal reveal="fade-from-bottom">
            <div
              v-html="item.title"
              class="text-left text-display-hero/none text-skin-base"
            ></div>
          </wrapper-reveal>
        </div>
      </section>
      <!-- end TOP BOX -->

      <!-- BOTTOM BOX -->
      <section
        class="overflow-hidden relative top-0 left-0 w-full min-h-[50vh]"
        :class="{
          'bg-skin-base': item.box2.asset,
          'bg-dynamic': !item.box2.asset,
        }"
        :style="`--color-fill-dynamic: ${setLuminance(
          item.box1.asset.dominant_color
        )};`"
      >
        <media
          v-if="item.box2.asset"
          v-bind="item.box2.asset"
          :sizes="sizes"
          :loading="index > 1 || forceLazyLoading ? 'lazy' : 'eager'"
          :use-bg="false"
          class="absolute inset-0 block w-full h-full overflow-hidden opacity-70"
          reveal="slide-from-up"
        />

        <div
          class="relative top-0 left-0 flex flex-col items-start w-full min-h-[50vh] p-edge justify-end"
          :class="{
            'overlay-gradient-from-bottom ': item.box2.asset,
          }"
        >
          <wrapper-reveal v-if="item.box2.overline" reveal="slide-from-right">
            <div
              class="text-overline text-skin-base"
              v-html="item.box2.overline"
            ></div>
          </wrapper-reveal>

          <wrapper-split-text
            v-if="item.box2.title"
            reveal="lines"
            :class="{
              'mt-sm tablet:mt-md': item.box2.overline,
            }"
          >
            <div
              class="text-heading-4 text-skin-base"
              v-html="item.box2.title"
            ></div>
          </wrapper-split-text>

          <wrapper-reveal
            v-if="item.box2.text"
            reveal="slide-from-bottom"
            class="w-10/12"
            :class="{
              'mt-md tablet:mt-lg': item.box2.overline || item.box2.title,
            }"
          >
            <div
              class="w-full text-body-big text-skin-base"
              v-html="item.box2.text"
            ></div>
          </wrapper-reveal>

          <wrapper-reveal
            v-if="item.box2.button?.title && item.box2.button?.action"
            :class="{
              'mt-xl tablet:mt-2xl':
                item.box2.overline || item.box2.title || item.box2.text,
            }"
            reveal="fade-from-right"
          >
            <btn-pill
              icon="arrow-long-right"
              :filled="true"
              :title="item.box2.button.title"
              :action="item.box2.button.action"
            />
          </wrapper-reveal>
        </div>
      </section>
      <!-- end BOTTOM BOX -->
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  sizes: {
    type: Object,
    required: true,
  },
  forceLazyLoading: {
    type: Boolean,
    required: false,
  },
});
const { setLuminance } = useColors();
</script>
